/**
 * РЈС‚РёР»РёС‚С‹ РґР»СЏ СЂР°Р±РѕС‚С‹ СЃ Telegram Mini Apps
 */
import type { TelegramWebAppData, TelegramUser } from '../types';

// Р Р°СЃС€РёСЂСЏРµРј window РґР»СЏ TypeScript
declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string;
        initDataUnsafe: TelegramWebAppData;
        ready: () => void;
        expand: () => void;
        close: () => void;
        openLink: (url: string, options?: { try_instant_view?: boolean }) => void;
        openTelegramLink?: (url: string) => void;
        MainButton: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isActive: boolean;
          show: () => void;
          hide: () => void;
          enable: () => void;
          disable: () => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
        };
        BackButton: {
          isVisible: boolean;
          show: () => void;
          hide: () => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
        };
        HapticFeedback: {
          impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
          notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
          selectionChanged: () => void;
        };
        themeParams: {
          bg_color?: string;
          text_color?: string;
          hint_color?: string;
          link_color?: string;
          button_color?: string;
          button_text_color?: string;
        };
      };
    };
  }
}

/**
 * РџСЂРѕРІРµСЂРёС‚СЊ, Р·Р°РїСѓС‰РµРЅРѕ Р»Рё РїСЂРёР»РѕР¶РµРЅРёРµ РІ Telegram
 */
export function isTelegramWebApp(): boolean {
  if (typeof window === 'undefined') return false;
  const webApp = window.Telegram?.WebApp;
  return Boolean(webApp?.initData?.trim() && webApp.initDataUnsafe?.user?.id);
}

/**
 * РџРѕР»СѓС‡РёС‚СЊ РґР°РЅРЅС‹Рµ РїРѕР»СЊР·РѕРІР°С‚РµР»СЏ РёР· Telegram
 */
export function getTelegramUser(): TelegramUser | null {
  if (!isTelegramWebApp()) {
    return null;
  }

  const user = window.Telegram?.WebApp.initDataUnsafe?.user;
  return user || null;
}

export function openExternal(url: string): void {
  if (isTelegramWebApp()) {
    try {
      window.Telegram!.WebApp.openLink(url);
      return;
    } catch (error) {
      console.warn('[Telegram] openLink failed, using browser fallback', error);
    }
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function sendPhotoToTelegramChat(
  generatedImageId: string,
): Promise<'success' | 'error' | 'forbidden' | 'no_auth'> {
  const initData = window.Telegram?.WebApp?.initData;
  if (!initData) return 'no_auth';

  try {
    const response = await fetch(`/api/generated/${encodeURIComponent(generatedImageId)}/send-to-telegram`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Telegram-InitData': initData,
      },
    });

    if (response.status === 403) return 'forbidden';
    if (!response.ok) return 'error';
    notificationFeedback('success');
    return 'success';
  } catch (error) {
    console.error('[Telegram] Failed to send generated image', error);
    return 'error';
  }
}

/**
 * РРЅРёС†РёР°Р»РёР·РёСЂРѕРІР°С‚СЊ Telegram WebApp
 */
export function initTelegramWebApp(): void {
  if (!isTelegramWebApp()) {
    console.warn('Not running in Telegram WebApp');
    return;
  }

  const webApp = window.Telegram!.WebApp;
  
  // РЎРѕРѕР±С‰Р°РµРј Telegram, С‡С‚Рѕ РїСЂРёР»РѕР¶РµРЅРёРµ РіРѕС‚РѕРІРѕ
  webApp.ready();
  
  // Р Р°Р·РІРѕСЂР°С‡РёРІР°РµРј РЅР° РІРµСЃСЊ СЌРєСЂР°РЅ
  webApp.expand();
  
  console.log('Telegram WebApp initialized');
}

/**
 * РџРѕРєР°Р·Р°С‚СЊ Main Button
 */
export function showMainButton(text: string, onClick: () => void): void {
  if (!isTelegramWebApp()) return;

  const mainButton = window.Telegram!.WebApp.MainButton;
  mainButton.text = text;
  mainButton.show();
  mainButton.enable();
  mainButton.onClick(onClick);
}

/**
 * РЎРєСЂС‹С‚СЊ Main Button
 */
export function hideMainButton(): void {
  if (!isTelegramWebApp()) return;
  window.Telegram!.WebApp.MainButton.hide();
}

/**
 * Haptic feedback
 */
export function hapticFeedback(type: 'light' | 'medium' | 'heavy' = 'medium'): void {
  if (!isTelegramWebApp()) return;
  window.Telegram!.WebApp.HapticFeedback.impactOccurred(type);
}

/**
 * Notification feedback
 */
export function notificationFeedback(type: 'error' | 'success' | 'warning'): void {
  if (!isTelegramWebApp()) return;
  window.Telegram!.WebApp.HapticFeedback.notificationOccurred(type);
}

/**
 * Р—Р°РєСЂС‹С‚СЊ Mini App
 */
export function closeTelegramWebApp(): void {
  if (!isTelegramWebApp()) return;
  window.Telegram!.WebApp.close();
}

/**
 * РџРѕР»СѓС‡РёС‚СЊ mock РїРѕР»СЊР·РѕРІР°С‚РµР»СЏ РґР»СЏ СЂР°Р·СЂР°Р±РѕС‚РєРё
 */
export function getMockUser(): TelegramUser {
  return {
    id: 123456789,
    first_name: 'Test',
    last_name: 'User',
    username: 'testuser',
  };
}

